import React,{ useState,}from 'react'
import { Modal,Form,message, Input} from 'antd';
import { useBnsJiaoChengKeShiAddMutation } from '../../store/ReactWebSiteApi';
import MyEditor from '../../cpn/MyEditor';
import { PlusSquareOutlined } from '@ant-design/icons';
function CourseAdd(props) {    
    const [form] = Form.useForm();
    const [add]  = useBnsJiaoChengKeShiAddMutation()
    const [info,setInfo] = useState({bjcks_bjc_id:''});
    //返回详情
    const [open, setOpen] = useState(false);
    return (
            <>
                <a onClick={() => {setOpen(true)}}><PlusSquareOutlined /> 新增</a>
                <Modal
                    open={open}
                    title='新增'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    width={1000}
                    onOk={() => {
                        add({
                            "bjcks_bjc_id" : props.bjc_id,
                            "bjcks_cid" : localStorage.getItem('eu_id'),
                            "bjcks_cname" : localStorage.getItem('eu_name'),
                            "bjcks_content" : info.bjcks_content,
                            "bjcks_name" : info.bjcks_name,                                                                      
                        }).then((res) => {
                            if (res.data.Status === 'success') {
                                message.info('新增成功！');
                                setOpen(false); 
                            }
                            if (res.data.Status === "fail") {
                                message.error('新增失败！'+res.data.Message)
                            }
                        })     
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}                        
                    >
                        <Form.Item name="bjcks_name" label='课时名称' wrapperCol={{span:20}} required>
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bjcks_name:e.target.value}))}}
                            />
                        </Form.Item> 
                        <Form.Item name="remark" label='备注' wrapperCol={{span:20}}>
                            <MyEditor
                                onChange={(e) => {setInfo(prevState=>({...prevState,bjcks_content:e}))}}
                                height={500}
                            />
                        </Form.Item> 
                    </Form>
                </Modal>
            </>
        )
}

export default CourseAdd